/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import StyleContext from 'isomorphic-style-loader/StyleContext';
import AppContext from '../AppContext';

class App extends React.PureComponent {
  static propTypes = {
    insertCss: PropTypes.func.isRequired,
    context: PropTypes.shape({
      fetch: PropTypes.func.isRequired,
    }),
    children: PropTypes.element.isRequired,
  };

  render() {
    const { insertCss, children, context } = this.props;
    return (
      <StyleContext.Provider value={{ insertCss }}>
        <AppContext.Provider value={context}>
          {React.Children.only(children)}
        </AppContext.Provider>
      </StyleContext.Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/components/App.js